import { my_clinic } from "../../js/path";

export default {
  data() {
    return {
      tableData: {
        doctors: [],
        total: 0,
        current_page: 1,
        last_page: 1,
        size: 20,
      },

      fields: [
        { key: "fname", label: "Doctor" },
        { key: "contact", label: "Contact" },
        { key: "patients_count", label: "Patients", sortable: true },
        { key: "appointment_counts", label: "Appointments" },
        { key: "token_summary", label: "Tokens" },
        { key: "wallet_summary", label: "Wallet (₹)" },
        { key: "billing_summary", label: "Billing (₹)" },
      ],

      currentPage: 1,
      filter: "",
      pageNo: null,
    };
  },

  methods: {
    // Main API call
    async fetchData() {
      const url =
        my_clinic.myClinicUrl +
        `?pagination=true&page=${this.currentPage}&size=20` +
        (this.filter ? `&search=${this.filter}` : "");

      this.updateUrl();

      this.$store.commit("loader/updateStatus", true);

      try {
        const res = await this.getRequest(url);

        if (res.status) {
          this.tableData = res.data;
        }
      } catch (err) {
        this.$store.commit("toast/updateStatus", {
          status: true,
          icon: "error",
          title: err?.data?.message || "Something went wrong",
        });
      }

      this.$store.commit("loader/updateStatus", false);
    },

    // Search button
    searchFor() {
      this.currentPage = 1;
      this.fetchData();
    },

    // Enter to search (clearing is handled by the filter watcher)
    search(event) {
      if (event.keyCode === 13) {
        this.currentPage = 1;
        this.fetchData();
      }
    },

    // Manual page input
    filterPage() {
      if (this.pageNo && this.pageNo > 0) {
        this.currentPage = Number(this.pageNo);
        this.fetchData();
      }
    },

    // Keep the browser URL in sync with the current search/page
    updateUrl() {
      const url = new URL(window.location);

      if (this.filter) url.searchParams.set("search", this.filter);
      else url.searchParams.delete("search");

      url.searchParams.set("page", this.currentPage);
      url.searchParams.set("size", 20);
      url.searchParams.set("pagination", true);

      history.pushState({}, "", url);
    },
  },

  watch: {
    currentPage(val) {
      if (val) this.fetchData();
    },
    filter(val) {
      if (!val) {
        this.currentPage = 1;
        this.fetchData();
      }
    }
  },

  created() {
    if (this.$route.query.search) {
      this.filter = this.$route.query.search;
    }

    if (this.$route.query.page) {
      this.currentPage = Number(this.$route.query.page);
    }

    this.fetchData();
  },
};